import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const DealsTeamLayout = () => {
     const navList = useNav();
  let {dealTeamBottomNav, topDealNav} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={dealTeamBottomNav} topTabs={topDealNav} />
            <Outlet />
        </div>
    )
}

export default DealsTeamLayout;